import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import { OfferPrintDto, OfferPrintStatusDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Return = {
  activeOfferTemplates: OfferPrintDto[];
  isLoading: boolean;
};

export const useGetActiveOfferTemplates = (): Return => {
  const { offerPrintApi } = useProcessApiClient();

  const { data, isLoading } = useQuery<OfferPrintDto[], AxiosError>({
    queryFn: async () => {
      const { data } = await offerPrintApi.searchOfferPrints(0, 200, {
        status: OfferPrintStatusDto.Active,
      });
      return data.items;
    },
    queryKey: [QueryKeyEnum.OFFER_PRINTS.ACTIVE],
    staleTime: 30_000,
  });

  return {
    activeOfferTemplates: data ?? [],
    isLoading,
  };
};
